import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  return (
    <footer
      className="border-t"
      style={{ borderColor: 'rgba(208,208,216,0.08)', background: 'var(--blackout)' }}
    >
      <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between gap-6">
        <AppLogo text="Viral" size={28} iconName="FilmIcon" />

        <nav className="flex flex-wrap items-center gap-x-8 gap-y-3 justify-center">
          {['Templates', 'Drops', 'Creators', 'Pricing', 'Blog']?.map((item) => (
            <a
              key={item}
              href="#"
              className="text-sm font-medium transition-colors duration-200"
              style={{ color: 'var(--chrome-dim)' }}
              onMouseEnter={e => (e.currentTarget.style.color = 'var(--chrome)')}
              onMouseLeave={e => (e.currentTarget.style.color = 'var(--chrome-dim)')}
            >
              {item}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-6">
          {['Twitter', 'TikTok', 'Instagram']?.map((s) => (
            <a
              key={s}
              href="#"
              className="text-xs font-semibold uppercase tracking-wider transition-colors duration-200"
              style={{ color: 'var(--chrome-faint)', letterSpacing: '0.1em' }}
              onMouseEnter={e => (e.currentTarget.style.color = 'var(--ruby)')}
              onMouseLeave={e => (e.currentTarget.style.color = 'var(--chrome-faint)')}
            >
              {s}
            </a>
          ))}
        </div>
      </div>
      <div
        className="border-t"
        style={{ borderColor: 'rgba(208,208,216,0.05)' }}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs" style={{ color: 'var(--chrome-dim)', opacity: 0.4 }}>
            © 2026 Viral Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {['Privacy', 'Terms']?.map((item) => (
              <a
                key={item}
                href="#"
                className="text-xs transition-colors duration-200"
                style={{ color: 'var(--chrome-dim)', opacity: 0.4 }}
                onMouseEnter={e => (e.currentTarget.style.opacity = '1')}
                onMouseLeave={e => (e.currentTarget.style.opacity = '0.4')}
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}